import { mq } from "@smoothincorg/smooth-ui"
import styled, { css } from "styled-components"

const styles = css`
  font-style: normal;
  font-weight: bold;
  font-size: 2rem;

  ${mq("sp_wide")} {
    font-size: 1.8rem;
  }
`

export const MiddleTitle = styled.h2`
  ${styles}
`
